import {NgModule} from '@angular/core';
import {routes} from "./routes";
import {SharedModule} from "../shared/shared.module";
import {RouterModule} from "@angular/router";
import {PagesModule} from "./pages/pages.module";
import {MenuService} from "../core/menu/menu.service";
import {TranslatorService} from "../core/translator/translator.service";
import {LayoutModule} from '../layout/layout.module';
import {DebtsModule} from "./debts/debts.module";
import {ControllersModule} from './controllers/controllers.module';
import {ConfigsModule} from "./configs/configs.module";
import {Router} from '@angular/router';
import {UtilitiesModule} from "./utilities/utilities.module";
import {GeneralModule} from './general/general.module';
import {IceCreamModule} from './ice-cream/ice-cream.module';
import { RmsService } from '../../../projects/jv-common/src/lib/services/rms.service';
import { ApiService } from '../../../projects/accounting/src/lib/services/api.service';


@NgModule({
    imports: [
        SharedModule,
        RouterModule.forRoot(routes),
        PagesModule,
        LayoutModule,
        DebtsModule,
        ControllersModule,
        ConfigsModule,
        UtilitiesModule,
        GeneralModule,
        IceCreamModule,
    ],
    declarations: [],

    exports: [
        RouterModule
    ]
})
export class RoutesModule {

    constructor(
        public menuService: MenuService,
        private tr: TranslatorService,
        private rms: RmsService,
        private router: Router,
        private api: ApiService
    ) {

        const general = {
            text: 'Quản lý',
            link: '/general',
            icon: 'fa fa-bars',
            condition: () => api.isManager()
        };
        const debt_heading = {
            heading: true,
            text: 'Công nợ',
        };
        const debt_outlets = {
            text: 'Cửa hàng',
            link: '/debts/outlets',
            icon: 'fa fa-home'
        };
        const debt_vendors = {
            text: 'Nhà cung cấp',
            classStyle: 'entrances',
            link: '/debts/vendors',
            icon: 'fa fa-sitemap'
        };
        const debt_customer = {
            text: 'Khách hàng',
            classStyle: 'customer',
            link: '/debts/customers',
            icon: 'fa fa-user'
        };

        const debt_service = {
            text: 'Dịch vụ',
            classStyle: 'entrances',
            link: '/debts/services',
            icon: 'fa fa-cog'
        };

        const controller_heading = {
            heading: true,
            text: 'Đối soát',
        };

        const controller_incomes = {
            text: 'Thu',
            link: '/controllers/incomes',
            icon: 'fa fa-plus-circle'
        };

        const controller_expenses = {
            text: 'Chi',
            link: '/controllers/expenses',
            icon: 'fa fa-minus-circle'
        };

        const controller_voucher = {
            text: 'Đổi điểm',
            link: '/controllers/voucher',
            icon: 'fa fa-empire'
        };
        const controller_onetimefees = {
            text: 'Phí cố định',
            link: '/controllers/one-time-fees',
            icon: 'fa fa-area-chart'
        };

        const controller_paymentmethod = {
            text: 'Cổng thanh toán',
            link: '/controllers/gateways',
            icon: 'fa fa-pie-chart'
        };

        const controller_ahapoint = {
            text: 'AHA Point',
            link: '/controllers/aha-point',
            icon: 'fa fa-amazon',
            classStyle: 'aha-point',
        };
        const controller_pending_ies = {
            text: 'Đơn hàng',
            link: '/controllers/pending-ies',
            icon: 'fas fa-warehouse',
        };
        const ice_cream_heading = {
            heading: true,
            text: 'Kho kem',
        };
        const ice_cream_transfer = {
            text: 'Nhập hàng',
            link: '/ice-cream/transfer',
            icon: 'fa fa-long-arrow-left',
        };
        const utilities_heading = {
            heading: true,
            text: 'Tiện ích',
        };
        const utilities_merge_transfer = {
            text: 'Gộp lệnh',
            link: '/utilities/merge-transfer',
            icon: '	fa fa-houzz'
        };

        const config_heading = {
            heading: true,
            text: 'Cấu hình',
        };
        const config_fees = {
            text: 'Phí hệ thống',
            link: '/configs/fees',
            icon: '	fas fa-dollar-sign'
        };
        const logout = {
            text: 'Đăng xuất',
            icon: 'fa fa-power-off',
            link: '#',
            action: () => {
                if (rms.logout()) {
                    router.navigate(['/login']);
                }
            }
        };

        const menu = [
            general,
            debt_heading,

            debt_outlets,
            debt_vendors,
            debt_customer,
            debt_service,
            controller_heading,
            controller_incomes,
            controller_expenses,

            // controller_voucher,
            controller_onetimefees,
            controller_paymentmethod,
            controller_ahapoint,

            controller_pending_ies,

            // ice cream
            //ice_cream_heading,
            //ice_cream_transfer,

            //
            utilities_heading,
            utilities_merge_transfer,
            config_heading,
            config_fees,
            logout
        ];
        this.menuService.addMenu(menu);
    }

}
// general
